import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import type { RootState } from "../root/config.store";
import {
  type LabelCatalog,
  LabelCatalogWithImages,
  initialState,
} from "../../types/labelCatalog";

interface LabelCatalogState {
  data: LabelCatalogWithImages[];
  loading: boolean;
  error: string | null;
  loadedPartNumbers: string[];
}

const initialLabelCatalogState: LabelCatalogState = {
  ...initialState,
  loadedPartNumbers: [],
};

export const labelCatalogSlice = createSlice({
  name: "labelCatalog",
  initialState: initialLabelCatalogState,
  reducers: {
    fetchAllisLoading(state) {
      state.loading = true;
      state.error = null;
    },
    fetchAllSucceeded(state, action: PayloadAction<LabelCatalog[]>) {
      const processed = action.payload.map((item) => ({
        ...item,
        images: item.labelCatalogThumbnails.map(
          (t) => `data:image/jpeg;base64,${t.fileURL}`
        ),
      }));

      const newItems = processed.filter(
        (item) => !state.loadedPartNumbers.includes(item.partNumber)
      );

      state.data = [...state.data, ...newItems];
      state.loadedPartNumbers.push(...newItems.map((item) => item.partNumber));
      state.loading = false;
      state.error = null;
    },
    fetchAllFailure(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
    resetCatalog(state) {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.loadedPartNumbers = [];
    },
  },
});

// Actions
export const labelCatalogActions = {
  fetchAll: createAction<string[]>("labelCatalog/fetchAll"),
  fetchAllisLoading: labelCatalogSlice.actions.fetchAllisLoading,
  fetchAllSucceeded: labelCatalogSlice.actions.fetchAllSucceeded,
  fetchAllFailure: labelCatalogSlice.actions.fetchAllFailure,
  resetCatalog: labelCatalogSlice.actions.resetCatalog,
};

export const selectlabelCatalog = (
  state: RootState
): LabelCatalogWithImages[] => {
  return state.labelCatalog?.data ?? [];
};

export default labelCatalogSlice.reducer;
